import React, { useCallback, useState, useEffect } from 'react';
import styled from 'styled-components';
import { bool, func, object, oneOfType, string } from 'prop-types';
import client from '../../../api/api';
import HumberDropdown from '../../../libs/humber-dropdown';

const media = {
  tablet: '@media(min-width: 768px)',
  desktop: '@media(min-width: 1366px)',
};

const InputProviderWrap = styled.div`
  margin-top: 20px;

  label {
    width: 100%;
    font-weight: 600;
    color: white;
  }

  input {
    background: transparent;
    border: none;
    height: 45px;
    font-size: 16px;
    color: white;
    width: 100%;
    border-bottom: 1px solid #787878;
  }

  input:focus {
    outline: none;
  }

  ${media.desktop} {
    padding: 0 15px;
  }
`;

const InputProvider = ({
  label,
  id,
  type,
  defaultValue,
  setValue,
  errorMsg,
  disabled,
  setErrorMsg,
}) => {
  const [list, setList] = useState([]);

  const getSelectOptions = useCallback(async () => {
    try {
      const { data } =
        id === 'truck-type'
          ? await client.endpoints.carrier.getTruckTypes()
          : await client.endpoints.carrier.getBodyTypeList();
      setList(data.sort((a, b) => a.label.localeCompare(b.label)));
    } catch (error) {
      setErrorMsg(
        id === 'truck-type'
          ? 'Error al obtener listado de tipos de camión'
          : 'Error al obtener listado de carrocerías'
      );
    }
  }, [id, setErrorMsg]);

  useEffect(() => {
    if (type === 'select') {
      getSelectOptions();
    }
  }, [getSelectOptions, type]);

  return (
    <InputProviderWrap>
      {type === 'select' && list.length > 0 ? (
        <HumberDropdown
          list={list}
          label={label}
          htmlFor={id}
          id={id}
          value={defaultValue}
          onChange={setValue}
          errorMsg={errorMsg}
          required
        />
      ) : (
        <label htmlFor={id}>
          {label}
          <input
            id={id}
            type={type}
            defaultValue={defaultValue}
            onChange={e => {
              setValue(e.target.value);
            }}
            disabled={disabled}
          />
        </label>
      )}
    </InputProviderWrap>
  );
};

InputProvider.propTypes = {
  id: string.isRequired,
  type: string.isRequired,
  defaultValue: oneOfType([string, object]).isRequired,
  label: string.isRequired,
  disabled: bool.isRequired,
  setValue: func,
  errorMsg: string.isRequired,
  setErrorMsg: func,
};

InputProvider.defaultProps = {
  setValue: () => {},
  setErrorMsg: () => {},
};

export default InputProvider;
